import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { RadioGroup } from '~/components/Form';

import { ConfirmationDialogRaw } from '~/components';
import { Spinner } from '~/components';

import { t } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close, cancelarAcao }) {

  const [isLoading, setIsLoading] = useState(false);

  //ConfirmationDialogRaw o registro do geral
  const [tituloConfirmationDialogRaw, setTituloConfirmationDialogRaw] = React.useState('CONFIRMAR');
  const [mensagemConfirmationDialogRaw, setMensagemConfirmationDialogRaw] = React.useState('Deseja confirmar a operação?');
  const [openConfirmationDialogRaw, setOpenConfirmationDialogRaw] = React.useState(false);
  const [valueConfirmationDialogRaw, setValueConfirmationDialogRaw] = React.useState("CLICK-OK");
  const [paramSubmit, setParamSubmit] = React.useState();

  const execHandleConfirmar = (param) => {
    setParamSubmit(param);
    //customizando a mensagem 
    //param.chkAlterarHodVeiculo === true ? 1 : 0
    setMensagemConfirmationDialogRaw(`Confirma salvar o novo status?`);
    setOpenConfirmationDialogRaw(true);
  };

  const handleConfirmationDialogRaw = (newValue) => {
    //console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        //handleSubmitConfirmar();
        setIsLoading(true);
        handleSubmit(paramSubmit)
      }
    } else {
      cancelarAcao();
      setIsLoading(false);
    }

  };

  async function handleSubmitPegunta(param) {
    await setIsLoading(true);
    await execHandleConfirmar(param);
  }





  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        rgpStatusNF: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        codNotaFiscal: data.desc_nf,
        status: param.rgpStatusNF,
      };

      await api.put('operacaonotafiscaldescargas', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await setIsLoading(false);

      await close();
    } catch (err) {
      await setIsLoading(false);
      await cancelarAcao();

      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <> {/* <> Para confirmação do form */}
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
        />
      </> {/* <> Para confirmação do form */}

      {isLoading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (

          <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmitPegunta}>
            <RadioGroup
              name="rgpStatusNF"
              label={`Selecione uma opção:`}
              //defaultValue={'1'}
              options={[
                {
                  label: `Nota Fiscal Cancelada`,
                  value: '1',
                  checkend: 'checkend'
                },
                {
                  label: `Nota Fiscal Retornada`,
                  value: '2',
                },
              ]}
              //disabled={typeUser === 'U'}
              serialize={(value) => Number(value)}
            />
          </ContainerForm>

        )}
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  cancelarAcao: PropTypes.func.isRequired,
  

  
};
